/* eslint-disable no-shadow */
import moment from 'moment';

const state = {
	expiration: moment().add(1, 'day').unix(),
	forms: {},
};

const getters = {
	// GET FORM
	form(st) {
		return (form) => {
			if (typeof st.forms[form] !== 'undefined') {
				return st.forms[form];
			}

			return false;
		};
	},
};

const mutations = {
	// INIT FORM INSTANCE
	SET_FORM(st, { form, fields }) {
		if (typeof st.forms[form] === 'undefined') st.forms[form] = {};
		Object.keys(fields).forEach((key) => {
			st.forms[form][key] = fields[key];
		});
	},
	// CLEAN FORM
	REMOVE_FORM(st, form) {
		if (typeof st.forms[form] !== 'undefined') delete st.forms[form];
	},
	// CLEAN ALL FORMS
	REMOVE_ALL_FORMS() {
		state.forms = {};
	},
};

const actions = {

};

export default {
	state,
	getters,
	actions,
	mutations,
};
